angular.module('st')
    .controller('eventSearchController', [
        '$rootScope','$scope',
        function ($rootScope,$scope) {
            var ctrl = this;

            $rootScope.eventSearchTerm = '';
            $scope.optionsExpanded = false;

            ctrl.handleInput = function (isMobile) {
                var offset = $('.events-list').offset().top;
                // 135 or 50 pixels is additional whitespace
                var scrollTop = offset - (isMobile == true ? 135 : 50);
                $('.event-search-desktop').css('top', '0px');
                $(document).scrollTop(scrollTop);
            }

            ctrl.jumpToMonth = function ($event, isMobile, month) {
                $event.preventDefault();
                var monthLink = $('#' + month);
                // additionalOffset adds some whitespace
                var additionalOffset = isMobile == true ? 140: 30;
                var scrollTop = monthLink.offset().top - additionalOffset;;
                $(document).scrollTop(scrollTop);
            }

            ctrl.isDropdownEmpty = function () {
                return $('.option-link.has-month').length == 0;
            }
        }
    ]);